/**
 * Rotating placeholder hints for the agent authoring composer (planning chat pattern).
 * Shown in the empty composer only — never sent as messages.
 */
export const AUTHORING_INPUT_EXAMPLE_PROMPTS: readonly string[] = [
  'Build a dynamic scheduling agent for injection molding with OTD and changeover constraints.',
  'I need an agent that analyzes workforce utilization and recommends shift changes.',
  'Create a quality floor agent for defect triage on a CNC production line.',
  'Help me define a digital transformation diagnostic agent for healthcare operations.',
  'Design an agent that sizes cost takeout opportunities from ERP and CRM data.',
  'I want an agent that proposes production schedules under machine ACL and plant setup.',
  'Define a customer churn analysis agent with clear success criteria and outputs.',
  'Build an agent for supplier risk assessment in automotive supply chain.',
  'Help me scope a maintenance planning agent with propose-and-approve governance.',
  'Create an agent that explains schedule trade-offs between OTD and utilization.',
];

export const AUTHORING_HINT_STEP_MS = 2200;
